import { Injectable, signal } from '@angular/core';
import { BulkEditReviewPanelState } from '@ps/survey-utils';
import { Nullable } from '@ps/utils';

@Injectable({ providedIn: 'root' })
export class BulkReviewPanelStateRegistry {
  public readonly currentState =
    signal<Nullable<BulkEditReviewPanelState>>(null);
}
